import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import issueActions from "../../_actions/issueActions";

class IssuePreview extends Component {
  handleClick_openIssue = e => {
    e.preventDefault();
    const { openIssue, issue } = this.props;
    openIssue(issue.issueId);
  };

  handleClick_follow = e => {
    const {
      issue,
      isFollowing,
      user,
      dispatch,
      refreshSelectedIssue
    } = this.props;
    e.preventDefault();

    if (issue.followers) {
      const issueFollower = {
        issueId: issue.issueId,
        followerUserId: user.userId
      };
      if (!isFollowing)
        dispatch(issueActions.followIssue(issueFollower)).then(() =>
          refreshSelectedIssue()
        );
      else
        dispatch(issueActions.unfollowIssue(issueFollower)).then(() =>
          refreshSelectedIssue()
        );
    }
  };

  render() {
    const {
      issue,
      isFollowing,
      renderPriority,
      statusEnum,
      typeEnum
    } = this.props;
    return (
      <div className="card">
        <div className="card-header">Issue Preview</div>
        <div className="card-body">
          {issue ? (
            <React.Fragment>
              <h4 className="mb-0">{issue.title}</h4>
              <small>
                <b>Issue #{issue.issueId}</b> - opened on{" "}
                {moment(issue.createdOn).format("MM/DD/YYYY")} by{" "}
                {issue.createdByUserFullName}
              </small>
              <div className="row mt-2">
                <div className="col">
                  <button
                    type="button"
                    name="openIssueDetails"
                    id="openIssueDetails"
                    className="btn btn-sm btn-secondary mr-2"
                    onClick={this.handleClick_openIssue}
                  >
                    <FontAwesomeIcon
                      icon="external-link-alt"
                      className="fa-fw mr-2"
                    />
                    View Issue...
                  </button>
                  <button
                    type="button"
                    name="followIssue"
                    id="followIssue"
                    className="btn btn-sm btn-outline-secondary mr-2"
                    onClick={this.handleClick_follow}
                  >
                    <FontAwesomeIcon icon="eye" className="fa-fw mr-2" />
                    {isFollowing ? "Unfollow" : "Follow"}
                  </button>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-10">
                  <ul className="list-group-flush border-bottom border-top pl-0 mb-2">
                    <li className="list-group-item pl-1 py-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Priority:</b>
                        </div>
                        <div className="col pl-1">{renderPriority(issue)}</div>
                      </div>
                    </li>
                    <li className="list-group-item pl-1 py-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Issue Type:</b>
                        </div>
                        <div className="col pl-1">
                          {typeEnum[issue.issueTypeId]}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item pl-1 py-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Status:</b>
                        </div>
                        <div className="col pl-1">
                          {statusEnum[issue.issueStatusId]}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item pl-1 py-1">
                      <div className="form-row">
                        <div className="col pr-1">
                          <b>Followers:</b>
                        </div>
                        <div className="col pl-1">
                          <FontAwesomeIcon
                            icon="users"
                            className="fa-fw text-muted mr-2"
                          />
                          {issue.followers ? issue.followers.length : 0}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item pl-1 py-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Replies:</b>
                        </div>
                        <div className="col pl-1">
                          <FontAwesomeIcon
                            icon="comments"
                            className="fa-fw text-muted mr-2"
                          />
                          {issue.posts ? issue.posts.length : 0}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item pl-1 py-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Description:</b>
                          <br />
                          {issue.bodyText}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <h5>No issue selected</h5>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.authentication.user
});

export default connect(mapStateToProps)(IssuePreview);
